import React, { PropTypes } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { animateScroll } from 'react-scroll';
import i18n from '../libs/i18n';

function mapStateToProps(state) {
  const { sections } = state;

  return { sections };
}

@connect(mapStateToProps)
export default class Nav extends React.Component {
  static propTypes = {
    sections: PropTypes.array,
    hidden: PropTypes.bool,
  };
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  hamburgerClickHandler = () => {
    const { isOpen } = this.state;

    this.setState({
      isOpen: !isOpen,
    });
  };

  render() {
    const { sections, hidden } = this.props;
    const { isOpen } = this.state;

    const styles = {
      wrapper: classnames({
        nav: true,
        'nav--hidden': hidden,
      }),
      beforeCrop: classnames('nav--before-crop'),
      content: classnames('nav--content'),
      hamburger: classnames({
        'nav--hamburger': true,
        'nav--hamburger--open': isOpen,
      }),
      list: classnames('nav--list'),
    };

    return (
      <nav className={styles.wrapper}>
        <div className={styles.beforeCrop}>
          <svg viewBox="0 0 100 6">
            <polygon points="0,5 100,0 100,6 0,6"></polygon>
          </svg>
          <svg viewBox="0 0 100 6">
            <polygon points="0,5 100,0 100,6 0,6"></polygon>
          </svg>
        </div>
        <div className={styles.content}>
          <div className={styles.hamburger} onClick={this.hamburgerClickHandler}>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <ul className={styles.list}>
            {
              Object.keys(sections).map((id) => {
                const s = sections[id];
                if (s.navTitle) {
                  const itemStyles = classnames({
                    'nav--item': true,
                    'nav--item--emphasis': s.navEmphasis,
                  });

                  const linkClickHandler = (e) => {
                    if (!s.isExternalLink) {
                      e.preventDefault();

                      // smooth scroll to
                      animateScroll.scrollTo(s.offset);

                      this.hamburgerClickHandler();
                    }
                  };

                  const idCamelCase = id.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
                  const labelPath = `${idCamelCase}.label`;

                  return (
                    <li key={`nav-item-${id}`} className={itemStyles}>
                      <a
                        href={s.navLink}
                        onClick={linkClickHandler}
                      >{i18n.translate(labelPath)}</a>
                    </li>
                  );
                }

                return null;
              })
            }
          </ul>
        </div>
      </nav>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/Nav.jsx
 **/